import React, { useState, useRef, useEffect } from "react";

import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Textarea from "react-validation/build/textarea";
import CheckButton from "react-validation/build/button";

import Helper from "../LocServices/Helper"
 
const required = (value) => {
    
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          This field is required!
        </div>
      );
    }
  };
/* 
        authData={{
          locationId: this.state.locationId,
          chat_id: this.props.user.chat_id,
          accessToken: this.props.user.accessToken,
        }} */
export default function SimpleFinderEdit (props) {
   const formRef = useRef(null);
   const checkBtn = useRef(null);

   const {reqLocId_edit, update_loc_simpleFinderMode} = props;
   const {formData, isLoading} = props
   //console.log(formData)
   const RxData = formData

/*    const RxData = 
      {
        "id": 20,
        "chat_id": 404529009,
        "message_id": 2216,
        "from_id": 404529009,
        "username": "xtalball_agent",
        "url": "https://go.2gis.com/6rh3mw",
        "text": "2Gis Led Solutions  https://go.2gis.com/6rh3mw",
        "description": "2Gis Led Solutions",
        "created_at": "2024-09-01T13:37:59.000Z",
        "gr_tags": "lf, kz, test"
      }
      console.log(RxData1) */

      const [data, setData] = useState({...RxData}); //loading is async data
      //console.log(data)
      
      const {gr_tags, url, text, description} = data //This is syncron data
      const handleTags = (event) => {
        setData({...data, gr_tags: event.target.value });
      };
      const handleUrl = (event) => {
        setData({...data, url: event.target.value });
      };
      const handleDescription = (event) => {
        setData({...data, description: event.target.value });
      };
      const handleText = (event) => {
        setData({...data, text: event.target.value });
      };
 
  // Handle form submission
  function handleSubmit(e) {
    //setData({...data, loading: true });
    e.preventDefault(); // Prevent default submission
    //setData({...data, loading: true });
    //setData((prevData) => ({ ...prevData, loading: true }));

    //console.log("I'm here 1")
    formRef.current.validateAll(); // Trigger validation
    // Check if validation passed
    if (checkBtn.current.context._errors.length !== 0) {
        console.log("Validation failed. Form submission stopped.");
        return  //stop handle Function
    }

    // *** Here validation passed ****
    //console.log(data)
    reqLocId_edit(data) //start edit process
    //setData({...data, loading: false });
    //console.log("I'm here 5")

  }


    return (
        <>
        <h1>Editor</h1>
        <Form
            onSubmit={handleSubmit}
            ref={formRef}

          >
            <div className="form-group">
              <label htmlFor="username">Tags</label>
              <Input
                type="text"
                className="form-control"
                name="tags"
                value={gr_tags}
                onChange={handleTags}
                validations={[required]}
              />
            </div>

            <div className="form-group">
              <label htmlFor="username">URL</label>
              <Input
                type="text"
                className="form-control"
                name="URL"
                value={url}
                onChange={handleUrl}
                validations={[required]}
              />
            </div>

            <div className="form-group">
              <label htmlFor="username">Text</label>
              <Input
                type="text"
                className="form-control"
                name="Description"
                value={text}
                onChange={handleText}
                validations={[required]}
              />
            </div>

            <div className="form-group">
                <label htmlFor="description">Description</label>
                <Textarea
                rows="8"
                cols="30"
                className="form-control"
                name="description"
                value={description}
                onChange={handleDescription}
                validations={[required]}
                />
            </div>

            <div className="simple-editor__btn-block form-group">
              <div className="simple-editor__btn-block--item">
              <button
                className="btn btn-primary btn-block"
                /* disabled={'false'} */
              >

                {isLoading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span>Update</span>
              </button>
              </div>
              <div className="simple-editor__btn-block--item">
              <button
                className="btn btn-secondary btn-block"
                /* disabled={'false'} */
                onClick={()=>{
                  //console.log('Hello click')
                  update_loc_simpleFinderMode("show")
                }}  
              >

                <span>Cancel</span>
              </button>
              </div>
            </div>


        <CheckButton
          style={{ display: "none" }}
          ref={checkBtn}
        />
          </Form>

        {/* <Helper props={data} />
        <Helper props={props} /> */}
        </>
    )
}